import { Injectable } from '@angular/core';
import { Observable, delay, retry, shareReplay, take } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { FeedbackType } from 'src/models/userFeedback';
import { AppSettings } from '../app-settings';
import { Platform } from '@ionic/angular';
import { Parish } from 'src/models/parish';

@Injectable({
    providedIn: 'root',
})
export class MiscService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient, private appSettings: AppSettings, private platform: Platform) { }

    getFeedbackTypes(): Observable<FeedbackType[]> {
        let url = this.appSettings.apiBaseUrl() + 'Misc/GetFeedbackTypes';

        return this.http.get<FeedbackType[]>(url, this.httpOptions)
        .pipe(
            retry({ count: 2, delay: 500}), shareReplay());
    }

    insertFeedback(profileId: number, feedback: string, feedbackTypeId: number): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + 'Misc/InsertFeedBack?profileId=' + profileId +
            '&feedback=' + feedback + '&feedbackType=' + feedbackTypeId;

        return this.http.get<boolean>(url, this.httpOptions)
        .pipe(
            retry({ count: 2, delay: 500}), shareReplay());
    }

    getParish(): Observable<Parish[]> {
        let url = this.appSettings.apiBaseUrl() + 'Misc/GetOurParish';

        return this.http.get<Parish[]>(url, this.httpOptions)
        .pipe(
            retry({ count: 2, delay: 500}), shareReplay());
    }

    getExternalResources(): Observable<any[]> {
        let url = this.appSettings.apiBaseUrl() + 'Misc/GetExternalResources';

        return this.http.get<Parish[]>(url, this.httpOptions)
        .pipe(
            retry({ count: 2, delay: 500}), shareReplay());
    }

    openExternalUrl(url: string) {
        if (this.platform.is('android')) {
            window.open(url, '_system');
        }
        else {
            window.open(url, '_system', "location=no");
        }
    }
}